
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.072 18.407c3.338.471 6.636.42 9.906 0 2.26-.29 3.788-1.769 4.149-3.87.41-2.391.394-4.881 0-7.46-.322-2.107-1.91-3.456-4.149-3.87-3.356-.62-6.658-.623-9.906 0-2.235.43-3.77 1.771-4.148 3.87-.442 2.457-.497 4.94 0 7.46.413 2.093 1.892 3.551 4.148 3.87z","fill":"#83CDFF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.35 6.469l1.574 2.72 1.662 2.87a2.08 2.08 0 01-.022 2.179c-.418.69-1.127 1.083-1.953 1.083H5.139c-.827 0-1.536-.393-1.954-1.083a2.08 2.08 0 01-.022-2.18L4.825 9.19 6.4 6.47c.411-.71 1.133-1.12 1.975-1.12.842 0 1.564.41 1.975 1.12z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.35 6.469l.71 1.227c-.62 1.19-1.565 2.385-2.789 3.44-1.686 1.452-3.584 2.365-5.29 2.668a2.07 2.07 0 01.182-1.746l1.662-2.87L6.4 6.468c.411-.71 1.133-1.12 1.975-1.12.842 0 1.564.41 1.975 1.12z","fill":"#136FAD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.177 9.76l.99 1.712 1.046 1.806c.254.438.25.936-.014 1.37a1.4 1.4 0 01-1.23.683h-4.072c-.52 0-.967-.248-1.23-.682a1.31 1.31 0 01-.014-1.371l1.046-1.806.99-1.712a1.4 1.4 0 011.244-.705 1.4 1.4 0 011.243.705z","fill":"#54B4F5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.177 9.76l.336.58a12.3 12.3 0 01-2.397 2.754 12.952 12.952 0 01-2.392 1.64 1.31 1.31 0 01-.07-1.456l1.046-1.806.99-1.712a1.4 1.4 0 011.244-.705 1.4 1.4 0 011.243.705z","fill":"#64BEFA"}})])
          )
        }
      }
    